<script>
import NoResults from '@components/notifications/no-results.vue';
import SearchInput from '@components/search-input/search-input.vue';
import cloneDeep from 'lodash/cloneDeep';
import {
  exerciseComputed,
  exerciseMethods,
  exerciseDifficultyComputed,
  muscleGroupComputed,
  equipmentComputed,
  adminPanelComputed,
  authComputed,
  organizationComputed,
} from '@state/helpers';

export default {
  components: {
    NoResults,
    SearchInput,
  },
  props: {
    hideDescription: {
      type: Boolean,
      required: false,
    },
    showExerciseFilters: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      newMuscleGroup: null,
      initialExerciseList: null,
      selectedExerciseDifficultyId: null,
      selectedMuscleGroupId: null,
      clearEquipmentSelection: null,
      selectedDifficulty: '',
      selectedEquipments: [],
      selectedMuscleGroup: '',
      searchComponentKey: 0,
      selectedFilters: [],
      ownerFilters: ['all'],
      searchOpts: {
        keys: ['label'],
      },
    };
  },
  computed: {
    ...exerciseComputed,
    ...exerciseDifficultyComputed,
    ...muscleGroupComputed,
    ...equipmentComputed,
    ...adminPanelComputed,
    ...authComputed,
    ...organizationComputed,
    hasExercises() {
      return this.allExercises && this.allExercises.length;
    },
    exercises() {
      if (
        this.selectedMuscleGroupId ||
        this.selectedExerciseDifficultyId ||
        this.selectedEquipments
      ) {
        let exercises = this.ownerFilterdExercises;
        if (this.selectedMuscleGroupId) {
          exercises = exercises.filter((exercise) => {
            const hasMuscleGroups =
              exercise.muscleGroups && exercise.muscleGroups.length;
            if (hasMuscleGroups) {
              const matchesMuscleGroup = exercise.muscleGroups.find(
                (group) => this.selectedMuscleGroupId === group.muscleGroup_id
              );

              if (matchesMuscleGroup) {
                return exercise;
              }
            }
          });
        }
        if (this.selectedExerciseDifficultyId) {
          exercises = exercises.filter((exercise) => {
            const exerciseDifficultyId =
              exercise.exerciseDifficulty &&
              exercise.exerciseDifficulty.exerciseDifficulty_id;
            if (exerciseDifficultyId === this.selectedExerciseDifficultyId) {
              return exercise;
            }
          });
        }
        if (this.selectedEquipments.length) {
          exercises = exercises.filter((exercise) => {
            const equipments = this.requiredEquipment(exercise);
            const hasEquipment = equipments && equipments.length;

            if (
              this.selectedEquipments &&
              this.selectedEquipments.length &&
              this.selectedEquipments.find(
                (equipment) => equipment._id === 'Bodyweight'
              ) &&
              !exercise.requiredEquipment.weighted
            ) {
              return exercise;
            }
            if (hasEquipment) {
              // AND filter
              const matchEquipment = this.selectedEquipments.every((filter) =>
                equipments.find((equipment) => filter._id === equipment)
              );
              if (matchEquipment) {
                return exercise;
              }
            }
          });
        }
        return exercises;
      } else {
        return this.ownerFilterdExercises;
      }
    },
    isInSplitPaneFull() {
      return (
        this.panelContent &&
        this.panelContent.data &&
        this.panelContent.data.componentRight &&
        !this.panelContent.data.componentRight.showPanelDetail
      );
    },
    isSmallPanel() {
      return (
        this.panelContent &&
        this.panelContent.data &&
        !this.panelContent.data.componentLeft
      );
    },
    selectedOwnerFilter() {
      return (
        this.ownerFilters &&
        this.ownerFilters.length > 0 &&
        this.ownerFilters[0]
      );
    },
    ownerFilterdExercises() {
      const filterName = this.ownerFilters[0];
      if (this.allExercises && this.allExercises.length > 0) {
        return this.allExercises.filter((exercise) => {
          if (filterName === 'mine' && exercise.trainer_id === this.trainerId) {
            return exercise;
          }
          if (filterName === 'sf' && exercise.trainer_id === '0') {
            return exercise;
          }
          if (filterName === 'all') {
            return exercise;
          }
        });
      }
      return this.allExercises;
    },
    allEquipmentSorted() {
      const index = this.sortingEquipment();
      const sortedEquipments = cloneDeep(this.allEquipment);
      sortedEquipments.splice(index, 0, {
        _id: 'Bodyweight',
        label: 'Bodyweight',
      });
      return sortedEquipments;
    },
  },
  created() {
    this.initialExerciseList = this.allExercises;
  },
  mounted() {
    this.clearEquipmentSelection = document
      .getElementById('equipmentFilter')
      .getElementsByClassName('vs__dropdown-toggle')[0]
      .getElementsByClassName('vs__actions')[0]
      .getElementsByClassName('vs__clear')[0];
    this.clearEquipmentSelection.addEventListener(
      'click',
      this.deselectAllEquipment
    );
  },
  async beforeDestroy() {
    await this.resetFilters();
  },
  methods: {
    ...exerciseMethods,
    toExercises() {
      this.$router.push({ name: 'exercises' });
    },
    onSelectMuscleGroup(value) {
      if (value) {
        this.selectedMuscleGroupId = value._id;
        this.selectedMuscleGroup = value.label;
      } else {
        this.selectedMuscleGroupId = null;
        this.selectedMuscleGroup = '';
      }
    },
    onSelectExerciseDifficulty(value) {
      if (value) {
        this.selectedExerciseDifficultyId = value._id;
        this.selectedDifficulty = value.label;
      } else {
        this.selectedExerciseDifficultyId = null;
        this.selectedDifficulty = '';
      }
    },
    isEquipmentSelected(id) {
      // For the v-select check mark
      return this.selectedEquipments.find((equipment) => equipment._id === id);
    },
    onSelectEquipments(val) {
      // Handle v-select click event
      const index = this.selectedEquipments.findIndex(
        (item) => item._id === val._id
      );
      if (index === -1) {
        this.selectedEquipments.push(val);
      } else {
        // Remove if equipment selected
        this.selectedEquipments.splice(index, 1);
      }
    },
    deselectAllEquipment() {
      this.selectedEquipments.splice(0, this.selectedEquipments.length);
    },
    onSelectExercise(exercise) {
      this.$emit('select-exercise-item', exercise);
    },
    onSelectOwnerFilters(val) {
      this.ownerFilters = [val];
    },
    onFilterResults(val) {
      this.setAllExercises(val);
    },
    resetFilters() {
      this.selectedMuscleGroupId = null;
      this.selectedExerciseDifficultyId = null;
      this.selectedDifficulty = '';
      this.selectedMuscleGroup = '';
      this.selectedEquipments = [];
      this.setAllExercises(this.initialExerciseList);
      this.searchComponentKey++;
    },
    requiredEquipment(exercise) {
      const listOfEquipment = [];
      if (
        exercise &&
        exercise.requiredEquipment &&
        exercise.requiredEquipment.weighted
      ) {
        listOfEquipment.push(exercise.requiredEquipment.weighted._id);
      }
      if (
        exercise &&
        exercise.requiredEquipment &&
        exercise.requiredEquipment.unweighted.length
      ) {
        exercise.requiredEquipment.unweighted.map((equipment) =>
          listOfEquipment.push(equipment._id)
        );
      }
      return listOfEquipment;
    },
    sortingEquipment() {
      const labels = this.allEquipment.map((equipment) => equipment.label);
      labels.push('Bodyweight');
      const sortedArray = labels.sort((a, b) => {
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        return 0;
      });
      const index = sortedArray.indexOf('Bodyweight');
      return index;
    },
  },
  watch: {
    isAdminPanelActive(val) {
      if (!val) {
        // Do not reset exercise filters when creating a workout in workouts or circuits
        // We might need this later
        // this.resetFilters();
      }
    },
    isInSplitPaneFull(val) {
      if (!val) {
        // Do not reset exercise filters when creating a workout in program
        // We might need this later
        // this.resetFilters();
      }
    },
    selectedEquipments() {
      this.clearEquipmentSelection.style.display = this.selectedEquipments
        .length
        ? 'unset'
        : 'none';
    },
  },
};
</script>

<template>
  <div class="exercises-list-wrapper">
    <div
      v-if="showExerciseFilters"
      :class="['exercise-filters', { smallPanel: isSmallPanel }]"
    >
      <SearchInput
        :key="searchComponentKey"
        :list="initialExerciseList"
        :options="searchOpts"
        @filter-results="onFilterResults"
      />
      <div class="row">
        <div class="col-3">
          <label for="muscle_group">Muscle Group</label>
          <v-select
            :options="allMuscleGroups"
            :searchable="false"
            :clearable="true"
            :value="selectedMuscleGroup"
            @input="onSelectMuscleGroup"
          />
        </div>
        <div class="col-3">
          <label for="level">Level</label>
          <v-select
            :options="allExerciseDifficulties"
            :searchable="false"
            :clearable="true"
            :value="selectedDifficulty"
            @input="onSelectExerciseDifficulty"
          />
        </div>
        <div class="col-12">
          <label for="equipment">Equipment</label>
          <v-select
            id="equipmentFilter"
            multiple
            :options="allEquipmentSorted"
            :searchable="false"
            :clearable="true"
            :value="selectedEquipments"
            :closeOnSelect="false"
            :class="'tdm-multi-select'"
          >
            <template v-slot:selected-option-container="{ option }">
              <div v-if="selectedEquipments && selectedEquipments.length > 1">
                {{ selectedEquipments.length }} Selected
              </div>
              <div v-else>{{ option.label }}</div>
            </template>
            <template v-slot:option="{ _id, label }">
              <div
                class="option-label-wrapper"
                @click="onSelectEquipments({ _id, label })"
              >
                <div>{{ label }}</div>
                <BaseIcon
                  class="icon-check"
                  name="check"
                  v-if="isEquipmentSelected(_id)"
                />
              </div>
            </template>
          </v-select>
        </div>
      </div>
      <div class="filter-own-exercises">
        <span
          id="exerciseAllOwnerButton"
          :class="{ selected: selectedOwnerFilter === 'all' }"
          @click="onSelectOwnerFilters('all')"
          >All Exercises</span
        >
        <span
          id="exerciseSFOwnerButton"
          :class="{ selected: selectedOwnerFilter === 'sf' }"
          @click="onSelectOwnerFilters('sf')"
          >{{ organizationTitle }} Exercises</span
        >
        <span
          id="exerciseMineOwnerButton"
          :class="{ selected: selectedOwnerFilter === 'mine' }"
          @click="onSelectOwnerFilters('mine')"
          >Custom Exercises</span
        >
      </div>
    </div>

    <NoResults v-if="!hasExercises">
      <h3 slot="title">No Results Found</h3>
      <p slot="text">
        We couldn't find any results that match your filters. Try changing your
        filters or search term. Or, if you need to create a new exercise, you
        can go ahead and do that, too.
      </p>
      <BaseButton
        slot="action"
        type="button"
        class="btn-primary btn-ghost btn-round"
        @click="toExercises"
      >
        Create New Exercise
      </BaseButton>
    </NoResults>

    <BaseListItem
      v-for="item in exercises"
      :key="item._id"
      :item="item"
      :hideDescription="hideDescription"
      @select-list-item="onSelectExercise"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown
// stylelint-disable no-descending-specificity

.exercises-list-wrapper {
  padding-bottom: 15rem;
  ::v-deep .list-item {
    .image-thumbnail {
      min-width: 10rem;
    }
  }
}
.option-label-wrapper {
  display: flex;
  justify-content: space-between;
}
.exercise-filters {
  .search-input-wrapper {
    margin-bottom: 1.6rem;
  }

  margin-bottom: 3rem;
  .v-select {
    width: 100%;

    ::v-deep .vs__dropdown-toggle {
      margin-bottom: 0 !important;
    }
  }
  .filter-own-exercises {
    align-items: center;
    background: $color-off-white;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    margin: 1em 0;
    padding: 0.75em;
    span {
      color: $color-black-one;
      cursor: pointer;
      font-family: $base-font-family;
      font-style: normal;
      font-weight: normal;
      letter-spacing: 0.11px;
      line-height: 22px;
      padding: 0.5em;
      text-align: center;
      white-space: nowrap;
      @include calc-font-size(0.85);
      &:hover {
        background: rgba($color-black-wo-rgb, 0.1);
        border-radius: 4px;
        font-weight: 800;
      }
      &.selected {
        background: $color-action;
        border-radius: 4px;
        color: $color-white;
        font-weight: 800;
      }
    }
    span + span {
      margin-left: 1em;
    }
    &.inPanel {
      span {
        font-size: 1.4rem;
      }
      #exerciseAllOwnerButton {
        margin-left: unset;
      }
      #exerciseMineOwnerButton {
        margin-right: 5px;
      }
    }
  }
  &.smallPanel {
    margin-top: 3%;
    .search-input-wrapper {
      margin-left: 3%;
      width: 92%;
    }
    .row {
      padding: 0 2em 1em 2em;
      .col-3 {
        flex: 0 0 45%;
        max-width: 45%;
        padding-bottom: 1em;
      }
    }
    .filter-own-exercises {
      margin: 1em 2em;
    }
  }
}
</style>
